/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getMyCalendarByPeriodYearRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');
export const getMyCalendarByPeriodMonthIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetMyCalendarByPeriod = zod.object({
  "year": zod.union([zod.number(),zod.string().regex(getMyCalendarByPeriodYearRegExpTwo)]).optional(),
  "monthId": zod.union([zod.number(),zod.string().regex(getMyCalendarByPeriodMonthIdRegExpTwo)]).optional()
});

export type GetMyCalendarByPeriod = zod.input<typeof GetMyCalendarByPeriod>;
export type GetMyCalendarByPeriodOutput = zod.output<typeof GetMyCalendarByPeriod>;
